module.exports = __webpack_public_path__ + "static/img/gopay-2-pc-bg.2a7b3f7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/gopay/gopay-2-pc-bg.png
// module id = Zvw/
// module chunks = 18